import { post } from '../libs/Axios';
import BaseFormComponent from '../abstracts/BaseFormComponent';
import SerializeForm from '../utilities/SerializeForm';

export default class ContatcFormComponent extends BaseFormComponent {
  get SELECTORS() {
    return {
      error: '.js-error',
      apply: '.js-apply',
    };
  }

  get CLASSES() {
    return {
      hidden: 'hide'
    };
  }

  constructor(element) {
    super(element);
    this.handleSubmit();
  }

  handleSubmit() {
    const formButton = this.$el.querySelector(this.SELECTORS.apply);
    this.onSubmit(async (e, action) => {
      this.loading(formButton);
      const formData = this.serializeForm(e.currentTarget).toObject();
      try {
        const { data } = await post(action, formData);

        if (data.error) {
          const error = this.$el.querySelector(this.SELECTORS.error);
          error.innerHTML = data.message;
          error.classList.remove(this.CLASSES.hidden);
        } else {
          document.querySelector('.js-contactus-text1').remove();
          document.querySelector('.js-contactus-text2').remove();
          this.$el.innerHTML = data;
        }
        this.endLoading(formButton);
        return data;
      } catch (err) {
        console.error(err);
        this.endLoading(formButton);
      }
    });
  }
}
